export default __webpack_public_path__ + "static/main-079e9121a8e1a131b75bc9dd4e702db4.mp4";